export const CategoryIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33325 4.33333C9.33325 2.58319 9.35199 2 11.6666 2C13.9812 2 13.9999 2.58319 13.9999 4.33333C13.9999 6.08348 14.0073 6.66667 11.6666 6.66667C9.32587 6.66667 9.33325 6.08348 9.33325 4.33333Z"
        stroke="#000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 11.6668C2 9.91669 2.01874 9.3335 4.33333 9.3335C6.64793 9.3335 6.66667 9.91669 6.66667 11.6668C6.66667 13.417 6.67405 14.0002 4.33333 14.0002C1.99262 14.0002 2 13.417 2 11.6668Z"
        stroke="#000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33782 1.93191C3.554 1.3012 4.446 1.3012 4.66218 1.93191L4.90997 2.65482C4.98006 2.85931 5.14069 3.01994 5.34518 3.09003L6.06809 3.33782C6.6988 3.554 6.6988 4.446 6.06809 4.66218L5.34518 4.90997C5.14069 4.98006 4.98006 5.14069 4.90997 5.34518L4.66218 6.06809C4.446 6.6988 3.554 6.6988 3.33782 6.06809L3.09003 5.34518C3.01994 5.14069 2.85931 4.98006 2.65482 4.90997L1.93191 4.66218C1.3012 4.446 1.3012 3.554 1.93191 3.33782L2.65482 3.09003C2.85931 3.01994 3.01994 2.85931 3.09003 2.65482L3.33782 1.93191Z"
        fill="#000"
      />
      <path
        d="M11.3378 9.93191C11.554 9.3012 12.446 9.3012 12.6622 9.93191L12.91 10.6548C12.9801 10.8593 13.1407 11.0199 13.3452 11.09L14.0681 11.3378C14.6988 11.554 14.6988 12.446 14.0681 12.6622L13.3452 12.91C13.1407 12.9801 12.9801 13.1407 12.91 13.3452L12.6622 14.0681C12.446 14.6988 11.554 14.6988 11.3378 14.0681L11.09 13.3452C11.0199 13.1407 10.8593 12.9801 10.6548 12.91L9.93191 12.6622C9.3012 12.446 9.3012 11.554 9.93191 11.3378L10.6548 11.09C10.8593 11.0199 11.0199 10.8593 11.09 10.6548L11.3378 9.93191Z"
        fill="#000"
      />
    </svg>
  );
};
